'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



//////////////////
// WEBPACK FOOTER
// ../~/querystring-es3/index.js
// module id = 1120
// module chunks = 0